import { getInvalidPostalCodesForCountry } from "@components/commerce/baseForms/utils/getInvalidPostalCodesForCountry";
import type { PostalCodeValidator } from "../types";
import { getQueryClient } from "@lib/helpers/queryClient";
import { successResult } from "../utils";

export const validateGB: PostalCodeValidator = async (args) => {
    const { postalCode, isBillingForm, headers, country } = args;
    // Don't run validation for billing form
    if (isBillingForm) return successResult();
    const queryClient = getQueryClient();
    const invalidPostalCodes = (await getInvalidPostalCodesForCountry(country, queryClient)) ?? [];

    const normalizedPostalCode = postalCode.toLocaleLowerCase().trim();

    // GB-specific validation: check if postal code starts with any invalid postal codes or matches SE4...1AN pattern
    const isInvalidPattern =
        normalizedPostalCode.startsWith("se4") && normalizedPostalCode.endsWith("1an");

    const isInvalidCode = invalidPostalCodes.some((code) =>
        normalizedPostalCode.startsWith(code.toLocaleLowerCase())
    );
    if (isInvalidPattern || isInvalidCode) {
        return {
            isValid: false,
            message: headers?.errors?.undeliverableAddress ?? "",
            key: "undeliverableAddress",
        };
    }

    return {
        isValid: true,
    };
};
